/*
 * @Descripttion: 主页用的header
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-01 16:08:14
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-08 15:55:48
 */
import React from 'react'
import Logo from './images/logo.png'
import { Link, Redirect } from 'react-router-dom'
import './style.css'
import { connect } from 'react-redux'
import { login, logout } from 'src/service/loginaction'
import { Button, Popover } from 'antd'
const content = (
    <img src="images/tempImgs/底部说明/qrCode.png" className='qrCode'>
    </img>
);
class HomeHearder extends React.Component {
    state = {
        headertype: 1
    }
    componentDidMount() {
        let href = window.location.href
        if (href.indexOf('/Home') !== -1) {
            this.setState({ headertype: 1 })
        } else {
            this.setState({ headertype: 2 })
        }

    }
    render() {
        if (this.props.loginObj && this.props.loginObj.login && this.props.loginObj.token !== undefined) {
            return <Redirect to='/Guide' />
        } else
            return (
                <div className="HomeHearder" >
                    <div className="HomeHearderMain">
                        <div className="HomeHearder_Loge" >
                            <Link to='/Home'>
                                {/* <img alt='logo' className="HomeHearder_LogeIcon" src={Logo} /> */}
                                <img alt='logo' className="HomeHearder_LogeIcon" src={"images/HomePage/logo.png"} />
                            </Link>
                            <div className="HomeHearder_Title" >
                                <div className={'HomeHearder_TitleText_cn'} >
                                    陆地观测卫星共性应用支撑平台
                                </div>
                                <div className={'HomeHearder_TitleText_en'} >
                                    Common application support platform for land observation satellite
                                </div>
                            </div>
                        </div>
                        <div className='HomeHearder_Login'>
                            {/* <div className='HomeHearder_Go'>走进空基</div> */}
                            <Link to='/UserLogin'>
                                <div className='HomeHearder_LoginButtons'>
                                    <img className='HomeHearder_LoginIcon' src='images/HomePage/User.png' />
                                    <div className='HomeHearder_LoginText'>未登录</div>
                                </div>
                            </Link>
                            {/* <Link to='/UserLogin'>
                                <div className='HomeHearder_LoginButton'>
                                    登录
                                </div>
                            </Link>
                            <Link to='/UserRegister'>
                                <div className='HomeHearder_Register'>
                                    注册
                                </div>
                            </Link> */}
                        </div>
                    </div>
                    <div className='downLoad'>
                        <div className='downLoadMain'>
                            {/*<a style={{ marginBottom: '10px' }} className='Guide_BottomTitle_RightDesktop' target="_blank" href={'https://caplos.aircas.ac.cn/oss/group1/M00/1D/FE/rBIAB2bs0R2AVIbLFLridyNmEaw852.exe '}>*/}
                            {/*    <img className='Guide_BottomTitle_RightDesktop_Icon' src="images/tempImgs/底部说明/desktop.png" />*/}
                            {/*    <div className='Guide_BottomTitle_RightDesktop_Text'>桌面端下载</div>*/}
                            {/*</a>*/}
                            {/*/!* <a className='Guide_BottomTitle_RightDesktop' href="http://caplos.aircas.ac.cn//oss/group1/M00/06/F6/rBIACmVfmjeATCirAAqkf7lIk1o573.png" target="_blank">*/}
                            {/*    <img className='Guide_BottomTitle_RightDesktop_Icon' src="images/tempImgs/底部说明/desktop.png" />*/}
                            {/*    <div className='Guide_BottomTitle_RightDesktop_Text'>桌面端下载</div>*/}
                            {/*</a> *!/*/}
                            {/*<Popover content={content}>*/}
                            {/*    <div className='Guide_BottomTitle_RightPhone'>*/}
                            {/*        <img className='Guide_BottomTitle_RightPhone_Icon' src="images/tempImgs/底部说明/phone.png" />*/}
                            {/*        <div className='Guide_BottomTitle_RightPhone_Text'>手机端下载</div>*/}
                            {/*    </div>*/}
                            {/*</Popover>*/}
                        </div>
                    </div>
                </div>
            )
    }
}

/**
 * 
 * @param {*} state 代表外部传来的数据
 */
const mapState = (state) => ({ //返回值  对应的是  组件的props
    // loginStatus: state.loginreducer.loginstate,
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch 
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({
    //组件中的方法名称 组件通过this.props.fucname(para1,para2)来调用方法
    // { type: 'increase' }定义了外部对这个方法的描述信息，
    // login: (userName, password) => dispatch({ type: 'login', userName: userName }),
    // logout: () => dispatch({ type: 'logout' })
    login: (param) => dispatch(login(param)),
    logout: () => dispatch(logout())
})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
export default connect(mapState, mapDispatch)(HomeHearder);